module.exports = __webpack_public_path__ + "33e6d0d11961c211babe03ee669df355.png";


//////////////////
// WEBPACK FOOTER
// ./apps/www.dawnofwar.com/src/static/img/power_has_a_price-320.webp.png
// module id = 509
// module chunks = 0